import { QuickDrawService } from '@pbl/pbl-react-core/lib/services/quick-draw-service';

class QuickDrawServiceAPI {
  public static getLatestQuickDrawWithWinnerResultByGame(gameId: number) {
    return QuickDrawService.getLatestQuickDrawWithWinnerResultByGame(gameId).then(response => {
      const result = {
        drawId: response.drawNumber,
        drawResult: response.winningNumbers.map(w => parseInt(w.data, 10))
      };
      return result;
    });
  }

  public static getQuickDrawJackpotResultsFromDrawDate(gameId: number, drawDateFrom: string, page?: number, size?: number) {
    return QuickDrawService.getQuickDrawJackpotResultsFromDrawDate(gameId, drawDateFrom, page, size).then(response => {
      const content = response.content;
      const result = content.map(r => ({
        drawId: r.externalId,
        drawResult: r.resultData.map(a => parseInt(a.data, 10))
      }));
      return result;
    });
  }

  public static getQuickDrawJackpotResultsByDrawId(gameId: number, drawId: string, page?: number, size?: number) {
    return QuickDrawService.getQuickDrawJackpotResultsByDrawId(gameId, drawId, page, size).then(response => {
      const content = response.content;
      const result = content.map(r => ({
        drawId: r.externalId,
        drawResult: r.resultData.map(a => parseInt(a.data, 10))
      }));
      // const result = {
      //   drawId,
      //   drawResult: content.resultData.map(c => parseInt(c.data, 10))
      // };
      return result;
    });
  }
}

export { QuickDrawServiceAPI };
